import { Button } from "@/components/shadcn/button";
import { KlipboardCrmInline } from "@/components/logos/KlipboardCrmInline";

export type ErrorPageProps = {
  message?: string;
};

export const ErrorPage = ({ message = "Sorry! We were unable to process your request." }: ErrorPageProps) => {
  const handleContinue = () => {
    if (window.opener != null) {
      window.close();
    } else {
      window.location.href = "/MyHome.aspx";
    }
  };

  return (
    <div className="flex flex-col min-h-screen font-sans">
      <nav
        role="navigation"
        className="layout-top-bar"
        style={{ backgroundColor: "var(--layout-top-nav-bg)" }}
      >
        <div className="flex items-center px-2">
          <a
            href="/MyHome.aspx"
            className="layout-logo-link flex items-center shrink-0 h-14.5 mr-1"
            aria-label="Home"
          >
            <span className="flex items-center self-start mt-1.5">
              <KlipboardCrmInline iconSize={29} />
            </span>
          </a>
        </div>
      </nav>

      <div className="flex flex-col items-center justify-center flex-1 p-6">
        <div className="w-full max-w-md space-y-6">
          <div className="rounded border border-warning bg-warning/10 px-4 py-3 text-warning-foreground text-center font-medium" role="alert">
            {message}
          </div>

          <div className="flex justify-center">
            <Button
              variant="default"
              onClick={handleContinue}
            >
              Click to Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
